export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20modern%20news%20editorial%20office%20with%20warm%20lighting%2C%20abstract%20data%20visualization%20elements%20floating%2C%20clean%20minimalist%20workspace%20atmosphere%2C%20documentary%20style%20photography%2C%20cream%20and%20warm%20gray%20tones%2C%20soft%20dramatic%20shadows%2C%20journalism%20and%20reporting%20theme%2C%20high%20detail%20editorial%20composition&width=1040&height=780&seq=about-51bl&orientation=landscape"
                alt="51爆料网平台介绍"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <span className="text-xs font-label font-semibold text-primary-500 uppercase tracking-wider">
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2 mb-5">
              关于51爆料
            </h2>
            <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                51爆料网成立于行业爆料内容需求快速增长的时代背景下，致力于打造一个真实、快速、全面的爆料信息聚合平台。
                我们汇聚全网各领域最新最热的爆料资讯，涵盖社会热点、行业动态、圈内秘闻、实时快讯等多个维度，
                为用户提供一站式的爆料内容浏览体验。
              </p>
              <p>
                平台坚持「真实性优先」的原则，所有爆料内容均经过多重信息核实流程，确保每一条发布的内容都经得起推敲。
                我们拥有一支专业的编辑团队，全天候不间断监测各类信息渠道，第一时间捕捉有价值的爆料线索。
              </p>
              <p>
                无论您是普通读者还是行业从业者，51爆料网都是您获取最新爆料资讯、了解行业风向的首选入口。
                我们欢迎每一位用户通过投稿通道分享有价值的爆料信息，共同打造一个透明、开放的信息交流社区。
              </p>
            </div>
            <div className="flex flex-wrap gap-6 mt-7">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500">
                  <i className="ri-shield-check-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">信息核实</div>
                  <div className="text-xs text-foreground-500">多重校验机制</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600">
                  <i className="ri-timer-flash-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">极速更新</div>
                  <div className="text-xs text-foreground-500">全天候不间断</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className="ri-group-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">开放投稿</div>
                  <div className="text-xs text-foreground-500">人人可参与</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}